var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 81.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,0C20.1,0,0,20.1,0,45c0,15,7.3,28.2,18.5,36.4C22.1,70.2,32.6,62.1,45,62.1c12.4,0,22.9,8.1,26.5,19.2     C82.7,73.2,90,59.9,90,45C90,20.1,69.9,0,45,0z M45,55.7c-9.5,0-17.1-7.7-17.1-17.1S35.5,21.4,45,21.4c9.5,0,17.1,7.7,17.1,17.1     S54.5,55.7,45,55.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.4bf398f2aee67e70b7186bbf9c450408.svg";
export { ForwardRef as ReactComponent };